import { render, staticRenderFns } from "./ProposalSourceTooltip.vue?vue&type=template&id=ec48e4fa&scoped=true"
import script from "./ProposalSourceTooltip.vue?vue&type=script&lang=js"
export * from "./ProposalSourceTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec48e4fa",
  null
  
)

export default component.exports